import Card from 'react-bootstrap/Card';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { TextButton } from 'Components/Button';
import { NumberedSteps } from 'Components/Public/NumberedSteps/NumberedSteps';
import { PageHeader } from 'Components/Public/PageHeader/PageHeader';
import { FloatingCallToAction } from 'Components/Public/FloatingCallToAction/FloatingCallToAction';
import { DidFindPrompt } from 'Components/Public/DidFindPrompt/DidFindPrompt';
import { useNavigate } from "react-router-dom";
import { retiredCommonFormats } from './RetiredFormatsData';
import { PATHS } from 'Utils/PagePaths';
import Feedback from "../../../Components/Public/Feedback/Feedback";
import { ReCaptchaWrapper } from "../../../Components/ReCaptcha";
import { Link } from 'react-router-dom';

function RetiredFormats () {

  const navigate = useNavigate();
  const intro = () => {
    return <Row className="mb-5 justify-content-center" >
      <Col
        xl={12}
        lg={12}
        md={10}
        sm={10}
        xs={10}
      >
        Retired Common Formats are no longer active for reporting and should be utilized for reference purposes
        only. These Common Formats should not be used by healthcare providers or Patient Safety Organizations
        (PSOs); the retired versions may be obtained by contacting the <Link to={PATHS.public['Get Help']} className="text-white">PSOPPC Help Desk</Link>.
      </Col>
    </Row>
      ;
  }

  const commonFormatsButton = () => {
    return <TextButton
      variant={"normal"}
      onClick={goToCurrentFormats}
      content={"Go to Current Common Formats"}
    />
  }

  const goToCurrentFormats = () => navigate(PATHS.public['Use Common Formats']);

  return (
    <>
      <ReCaptchaWrapper
        action="retired_formats_landing"
        title="Retired Common Formats"
      >
        <Row className="m-0 p-0">
          <PageHeader
            title="Retired Common Formats (Reference Only)"
            intro={intro()}
            children={commonFormatsButton()}
          >
          </PageHeader>
        </Row>
  
        {/*<p>*/}
        {/*  <h2 className="public-title text-center mb-3 retired-format-title">*/}
        {/*    Retired AHRQ Common Formats*/}
        {/*  </h2>*/}
        {/*  <br/>*/}
        {/*</p>*/}
        <Row className="m-0 mt-4 p-0 justify-content-center mb-5">
          <Col
            xl={8}
            lg={10}
            md={12}
          >
            {retiredCommonFormats?.map((cf, idx) => (
              <Card
                key={`retired-cf-${idx}`}
                className="mb-4 mt-2 shadow-sm retired-format-card mx-auto"
              >
                <Card.Header className="border-0 pb-0 mt-4 mb-1 retired-format-card-header">
                  <Row className="justify-content-center">
                    <Col
                      xl={8}
                      lg={9}
                      md={10}
                      sm={12}
                      className="text-start ps-3 ps-sm-3 ps-md-3 ps-lg-2 ps-xl-2 pe-3 text-break"
                    >
                      <h2 className="h5 m-0 header2">
                        {cf.title}
                      </h2>
                    </Col>
                  </Row>
                </Card.Header>
  
                <Card.Body className=" ps-3 pe-3">
                  <Row className="justify-content-center">
                    <Col
                      xl={8}
                      lg={9}
                      md={10}
                      sm={12}
                      className="text-start ps-3 ps-sm-3 ps-md-3 ps-lg-2 ps-xl-2 pe-3 mb-3 text-break body"
                    >
                      <p className="mb-1 body">
                        <span>Published:</span>{" "}
                        {cf.publishMonth} {cf.publishYear}
                      </p>
                      <p className="mb-0 body">
                        <span>Retired:</span>{" "}
                        {cf.retiredMonth} {cf.retiredYear}
                        {cf.retireMessage ? ` (${cf.retireMessage})` : ""}
                      </p>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            ))}
          </Col>
        </Row>
      </ReCaptchaWrapper>


      <DidFindPrompt></DidFindPrompt>
      <Feedback/>
    </>


  );
}

export default RetiredFormats;
